import type { UserRoles } from "~enums/userRoles";
import { DEFAULT_ROLE_CONFIG, userRolesConfig } from "../../constants/userRolesConfig";
import type { PermissionProducts } from "../../enums/permissionProducts";
import type { UserPermissionTransformed } from "../../types";

const groupPermissionsByProduct = (
  permissions: UserPermissionTransformed[],
): { [key in PermissionProducts]?: UserPermissionTransformed[] } =>
  permissions.reduce((accumulator, currentValue) => {
    const roleConfig = userRolesConfig[currentValue.userRole as UserRoles] || DEFAULT_ROLE_CONFIG;
    if (roleConfig.product in accumulator) {
      accumulator[roleConfig.product].push(currentValue);
    } else {
      accumulator[roleConfig.product] = [currentValue];
    }
    return accumulator;
  }, {});

export default groupPermissionsByProduct;
